/**
 * Custom hook for company actions (assign, edit, delete)
 */
import { useState } from "react";
import { toast } from "sonner";
import { apiClient, getErrorMessage } from "../../../utils/api";

export const useCompanyActions = (companyId, token, refetch, navigate) => {
  const [assigning, setAssigning] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleAssign = async (selectedAgentId, onSuccess) => {
    if (!selectedAgentId) {
      toast.error("Odaberite agenta");
      return;
    }
    setAssigning(true);
    try {
      const response = await apiClient.post('/companies/assign', {
        company_ids: [companyId],
        agent_id: selectedAgentId
      });
      toast.success(`Firma dodijeljena agentu ${response.data.agent_name}`);
      onSuccess?.();
      refetch();
    } catch (error) {
      console.error("Assignment failed:", error);
      toast.error(getErrorMessage(error));
    } finally {
      setAssigning(false);
    }
  };

  const handleUnassign = async () => {
    setAssigning(true);
    try {
      await apiClient.post('/companies/unassign', [companyId]);
      toast.success("Firma oduzeta od agenta");
      refetch();
    } catch (error) {
      console.error("Unassign failed:", error);
      toast.error(getErrorMessage(error));
    } finally {
      setAssigning(false);
    }
  };

  const handleSaveEdit = async (editForm, onSuccess) => {
    setSaving(true);
    try {
      await apiClient.put(`/companies/${companyId}`, editForm);
      toast.success("Podaci firme ažurirani");
      onSuccess?.();
      refetch();
    } catch (error) {
      console.error("Update failed:", error);
      toast.error(getErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteCompany = async (companyName, onSuccess) => {
    setDeleting(true);
    try {
      const response = await apiClient.delete(`/companies/${companyId}`);
      toast.success(`Firma "${response.data.deleted_company}" obrisana`);
      navigate("/");
    } catch (error) {
      console.error("Delete company failed:", error);
      toast.error(getErrorMessage(error));
    } finally {
      setDeleting(false);
      onSuccess?.();
    }
  };

  const handleDeleteActivity = async (activityId, onSuccess) => {
    setDeleting(true);
    try {
      await apiClient.delete(`/activities/${activityId}`);
      toast.success("Aktivnost obrisana");
      onSuccess?.();
      refetch();
    } catch (error) {
      console.error("Delete activity failed:", error);
      toast.error(getErrorMessage(error));
    } finally {
      setDeleting(false);
    }
  };

  return {
    assigning,
    saving,
    deleting,
    handleAssign,
    handleUnassign,
    handleSaveEdit,
    handleDeleteCompany,
    handleDeleteActivity
  };
};
